var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionMixedLoadingMobile = function SvgCollectionMixedLoadingMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 360 552"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 0h160v90H16z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102.128,
    height: 12,
    x: 16,
    y: 98,
    fill: "#1A1A1A",
    rx: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M184 0h160v90H184z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 102.128,
    height: 12,
    x: 184,
    y: 98,
    fill: "#1A1A1A",
    rx: 6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 156h160v90H16z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 102.128,
    height: 12,
    x: 16,
    y: 254,
    fill: "#1A1A1A",
    rx: 6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M184 156h160v90H184z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 102.128,
    height: 12,
    x: 184,
    y: 254,
    fill: "#1A1A1A",
    rx: 6
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 312h160v90H16z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 102.128,
    height: 12,
    x: 16,
    y: 410,
    fill: "#1A1A1A",
    rx: 6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M184 312h160v90H184z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 102.128,
    height: 12,
    x: 184,
    y: 410,
    fill: "#1A1A1A",
    rx: 6
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M16 468h160v90H16z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M184 468h160v90H184z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 184,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 16,
    y: 156,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 184,
    y: 156,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 16,
    y: 312,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 184,
    y: 312,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 16,
    y: 468,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 90,
    x: 184,
    y: 468,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgCollectionMixedLoadingMobile;